// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1XF_7","inner":"Form_inner__NiSzo","range":"Form_range__g0N2U","name":"Form_name__1LcAl","actions":"Form_actions__2WQgI"};